import { useMutation } from '@tanstack/react-query';

import useApi from '../use-api';

import type { ICheckAvailability } from 'infrastructure/interfaces/i-check-availability';

const patientCheckAvailabilityApi = (patientGuid: string) =>
  `core-2/patients/${patientGuid}/check-availability`;

export const usePatientCheckAvailability = () => {
  const { loadData } = useApi();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({
      patientGuid,
      patientPhone,
    }: {
      patientGuid: string;
      patientPhone: string;
    }) => {
      const res = await loadData<ICheckAvailability>(
        patientCheckAvailabilityApi(patientGuid),
        {
          phone: `${patientPhone}`,
        },
      );
      return res as ICheckAvailability;
    },
  });

  return {
    isLoading,
    mutateAsync,
  };
};
